import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-terms-of-service-template',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-of-service-template.component.html',
})
export class TermsOfServiceTemplateComponent {}
